import filterMoviesByTimeRangeAndCinema from "./filterMoviesByTimeRangeAndCinema"
import { getFromWeekCinemaEndDate, getFromWeekCinemaStartDate } from '../getDateFromWeek'


const filterMoviesByWeekAndCinemas = (order, items, performances, weekObj, cinemaIds = false) => {
    const weekPeriodeStartDate = getFromWeekCinemaStartDate(weekObj.isoWeek, weekObj.year)
    const weekPeriodeEndDate = getFromWeekCinemaEndDate(weekObj.isoWeek, weekObj.year)

    return filterMoviesByTimeRangeAndCinema(order, items, performances, weekPeriodeStartDate, weekPeriodeEndDate, cinemaIds)
}

export default filterMoviesByWeekAndCinemas